import {useQuery} from "@tanstack/react-query";
import {readOrderSubjects} from "../../../../../api/order/OrdersApi";
import {ordersDetailSubjectInit} from "../state";

type Props = {
    param: string;
    enabled?: boolean
};

export const useReadOrderSubjects = ({param, enabled}: Props) => {
    const {data} = useQuery({
        queryKey: ["readOrderSubjects", param],
        queryFn: async () => await readOrderSubjects(param),
        select: (res) => res?.data.result ?? ordersDetailSubjectInit,
        enabled: enabled
    });

    return {data};
};
